import type { ChangeEvent } from "react";
import { HelpPopover } from "../../components/HelpPopover.tsx";

const RealPlayerDeterminismForm = ({
	realPlayerDeterminism,
	handleChange,
	godMode,
}: {
	realPlayerDeterminism?: number;
	handleChange: (
		type: string,
		field: string,
		event:
			| ChangeEvent<HTMLInputElement | HTMLSelectElement>
			| {
					target: {
						value: any;
						checked?: boolean;
					};
			  },
	) => void;
	godMode: boolean;
}) => {
	const enabled = realPlayerDeterminism !== undefined;
	const value = realPlayerDeterminism !== undefined ? Math.round(realPlayerDeterminism * 100) : 100;

	return (
		<div className="mb-3">
			<label className="form-label d-flex align-items-center">
				Real Player Determinism Override
				<HelpPopover title="Real Player Determinism Override">
					<p>
						Real Player Determinism (RPD) controls how much a player's development
						is based on their real-life career stats versus random variation.
					</p>
					<p>
						By default, all players use the global RPD setting from the league
						settings. This override allows you to set a specific RPD value for
						this player.
					</p>
					<ul>
						<li>
							<b>0%:</b> Completely random development (no real-life influence).
						</li>
						<li>
							<b>100%:</b> Development follows real-life career perfectly.
						</li>
					</ul>
				</HelpPopover>
			</label>

			<div className="form-check mb-2">
				<label className="form-check-label">
					<input
						className="form-check-input"
						type="checkbox"
						checked={enabled}
						disabled={!godMode}
						onChange={(e) => handleChange("realPlayerDeterminism", "enabled", e)}
					/>
					Enable Override
				</label>
			</div>

			{enabled && (
				<div className="mb-2">
					<label className="form-label">
						Determinism: {value}%
					</label>
					<input
						type="range"
						className="form-range"
						min="0"
						max="100"
						step="1"
						value={value}
						disabled={!godMode}
						onChange={(e) => handleChange("realPlayerDeterminism", "value", e)}
					/>
					<div className="d-flex justify-content-between">
						<small>0% (Random)</small>
						<small>100% (Real)</small>
					</div>
				</div>
			)}
		</div>
	);
};

export default RealPlayerDeterminismForm;
